import { CurriculumEventBase } from '../curriculumEventBase';

type Session = {
  sessionId: string;
  name: string;
};

type SessionTimelineSegment = {
  activity: string;
  group: string;
  leader: string;
  name: string;
  isFlex: boolean;
  enabled: boolean;
};

type SegmentReorderedEventPayload = {
  eventSubType: 'Session Timeline Segment Reordered';
  session: Session;
  segment: SessionTimelineSegment;
  fromIndex: number;
  toIndex: number;
};

export class SegmentReorderedEvent extends CurriculumEventBase<SegmentReorderedEventPayload> {
  public static format(
    session: Session,
    segment: SessionTimelineSegment,
    fromIndex: number,
    toIndex: number
  ): SegmentReorderedEventPayload {
    const { sessionId, name: sessionName } = session;
    const { activity, group, leader, name: segmentName, isFlex, enabled } = segment;
    return {
      eventSubType: 'Session Timeline Segment Reordered',
      session: { sessionId, name: sessionName },
      segment: { activity, group, leader, name: segmentName, isFlex, enabled },
      fromIndex,
      toIndex,
    };
  }
}
